export enum RouteMap {
  //public
  PUBLIC_LOGIN_INIT = 'public/login/init',
  PUBLIC_RESETPASSWORD_INIT = 'public/resetpassword/init',
  PUBLIC_RESETPASSWORD_SETPASSWORD = 'public/resetpassword/setpassword',

  //private
  PRIVATE_REPORTABONAMENTS = 'private/reportabonaments',
}
